<span [ngClass]="classesArray" [style.margin]="margin"> <ng-content></ng-content> </span>
